import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { m as p } from "./tss-DN0acMKN.mjs";
import { M as g, d as b } from "./constants-CnFYFetN.mjs";
import { B as C } from "./Box-B5hjovXR.mjs";
import { r as d } from "./index-lgh2EImO.mjs";
import { I as F } from "./icon-tile-BJ1ib0c2.mjs";
import { l as v } from "./lodash-5ofSKtz3.mjs";
import { S as w } from "./Stack-BsxljEnZ.mjs";
import { B as f } from "./Box-BghdyyLI.mjs";
import { T as y } from "./Typography-DfkimCSn.mjs";
const S = p({ name: "Tile" })(
  ({ palette: r, borderRadiuses: i, mixins: n, constructs: o, mode: a }, s, l) => ({
    root: {
      transition: "background-color 0.15s, border-color 0.15s ease-in-out",
      borderRadius: e.ifFeature("encore", i[400], 8),
      borderWidth: e.ifFeature("encore", 1, 2),
      boxSizing: "border-box",
      // inner border
      borderStyle: "solid",
      outline: a === g.Dye ? `1px solid ${b.main}` : void 0
    },
    primary: {
      backgroundColor: e.ifFeature("encore", o.surface.neutral.xxWeak, r.gray[100]),
      borderColor: e.ifFeature("encore", o.border.neutral.xWeak, r.gray[100]),
      boxShadow: e.ifFeature("encore", n.boxShadow("300", o.surface.neutral.xxStrong)),
      "&:hover, &:focus, &:focus-within": e.ifFeature(
        "encore",
        {},
        {
          backgroundColor: r.gray[200],
          borderColor: r.gray[200]
        }
      )
    },
    secondary: {
      backgroundColor: "none",
      borderColor: e.ifFeature("encore", o.border.neutral.weak, r.gray[200]),
      boxShadow: e.ifFeature("encore", n.boxShadow("300", o.surface.neutral.xxStrong))
    },
    placeholder: {
      borderColor: r.gray[300],
      borderStyle: "dashed",
      "&:hover, &:focus, &:focus-within": e.ifFeature(
        "encore",
        {},
        {
          borderColor: r.gray[400]
        }
      )
    },
    active: e.ifFeature(
      "encore",
      {},
      {
        [`&.${l.primary}`]: {
          backgroundColor: r.gray[200],
          borderColor: r.gray[200]
        },
        [`&.${l.placeholder}`]: {
          borderColor: r.gray[400]
        }
      }
    )
  })
), H = ({ variant: r = "primary", isActive: i, ...n }) => {
  const { classes: o, cx: a } = S();
  return /* @__PURE__ */ c.jsx(
    C,
    {
      className: a([
        o.root,
        r === "primary" && o.primary,
        r === "secondary" && o.secondary,
        r === "placeholder" && o.placeholder,
        i && o.active
      ]),
      height: e.ifFeature("encore", 184, 148),
      width: e.ifFeature("encore", 200, 224),
      ...n,
      "data-fabric-component": "Tile"
    }
  );
}, j = p({ name: "TileContent" })(
  ({ palette: r, spacing: i, typography: n }, o, a) => ({
    root: {
      alignItems: e.ifFeature("encore", "flex-start", "center"),
      height: "100%",
      padding: e.ifFeature("encore", `${i(2.5)} ${i(2.5)}`, `${i(0.5)} ${i(2.5)}`),
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      position: "relative",
      width: "100%",
      boxSizing: "border-box",
      [`&:hover .${a.actionContainer}, &:focus-within .${a.actionContainer}`]: {
        opacity: 1,
        pointerEvents: "auto"
      }
    },
    iconContainer: {
      alignItems: "flex-end",
      display: "flex",
      height: e.ifFeature("encore", void 0, 54),
      justifyContent: "center",
      paddingBottom: e.ifFeature("encore", i(2), i(0.5)),
      fill: r.primary.main
    },
    iconContainer__secondary: {
      [`&.${a.iconContainer}`]: {
        fill: r.grey[600]
      }
    },
    actionContainer: {
      transition: "opacity 0.15s ease-in-out",
      pointerEvents: "none",
      opacity: 0,
      fontSize: e.ifFeature("encore", n.small.fontSize),
      lineHeight: e.ifFeature("encore", n.small.lineHeight),
      maxHeight: e.ifFeature("encore", 20)
    },
    typographyContainer: {
      textAlign: e.ifFeature("encore", "left", "center"),
      display: "block",
      width: "100%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    active: {
      [`& .${a.actionContainer}`]: {
        opacity: 1,
        pointerEvents: "auto"
      }
    }
  })
), O = (r) => {
  const { title: i, subtitle: n, icon: o, actionsDropdown: a, primaryAction: s, variant: l = "primary", isActive: h, ...x } = r, { classes: t, cx: u } = j(), m = v.uniqueId();
  return /* @__PURE__ */ c.jsxs(
    w,
    {
      "aria-labelledby": m,
      className: u([t.root, h && t.active]),
      role: "region",
      ...x,
      "data-fabric-component": "TileContent",
      children: [
        a && /* @__PURE__ */ c.jsx(
          f,
          {
            className: t.actionContainer,
            position: "absolute",
            right: e.ifFeature("encore", 16, 8),
            top: e.ifFeature("encore", 16, 8),
            children: d(a)
          }
        ),
        /* @__PURE__ */ c.jsx(f, { className: u([t.iconContainer, l === "secondary" && t.iconContainer__secondary]), children: e.ifFeature(
          "encore",
          typeof o == "string" ? /* @__PURE__ */ c.jsx(F, { icon: o, size: 64, variant: l === "primary" ? "primary" : void 0 }) : null,
          d(o)
        ) }),
        /* @__PURE__ */ c.jsx(
          y,
          {
            className: t.typographyContainer,
            color: e.ifFeature("encore", "primary.main", l === "primary" ? "gray.900" : "gray.700"),
            fontWeight: e.ifFeature("encore", 600, l === "primary" ? 700 : 600),
            id: m,
            mb: e.ifFeature("encore", 0, 0.25),
            variant: e.ifFeature("encore", "medium", "large"),
            children: i
          }
        ),
        n && /* @__PURE__ */ c.jsx(
          y,
          {
            className: t.typographyContainer,
            color: e.ifFeature("encore", "gray.800", "gray.700"),
            variant: e.ifFeature("encore", "teenie", "small"),
            children: n
          }
        ),
        s && /* @__PURE__ */ c.jsx(f, { className: t.actionContainer, justifySelf: "flex-end", mt: e.ifFeature("encore", "4px", "auto"), children: d(s) })
      ]
    }
  );
};
export {
  H as T,
  O as a
};
//# sourceMappingURL=tile-content-Bb_XOh3-.mjs.map
